import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { GlobalService } from '../../global.service';
import { MatDialog, ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { BusinessTypeWiseProductDiscountEditDialogComponent } from 'src/app/discount-product/business-type-wise-product-discount-edit-dialog/business-type-wise-product-discount-edit-dialog.component';
import { BusinessTypeWiseProductPriceComponent } from '../business-type-wise-product-price/business-type-wise-product-price.component';

@Component({
  selector: 'app-by-product-price-list',
  templateUrl: './by-product-price-list.component.html',
  styleUrls: ['./by-product-price-list.component.scss']
})
export class ByProductPriceListComponent implements OnInit {
  title = '';
  by_product_group_list: any;
  by_product_dict: any;
  business_types: any;
  discount_price_for_selected_business_type: any;
  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  selected_business_type_id = null;

  constructor(private httpService: HttpService, private globalService: GlobalService, private dialog: MatDialog) {
    this.getDiscountBusiness();
    this.serveProductList();
    this.title = this.globalService._active_display_name;
  }

  serveProductList() {
    this.is_data_available = false;
    this.httpService.serveByProductList().subscribe((data) => {
      console.log(data);
      this.is_data_available = true;
      this.by_product_group_list = data["by_product_group_list"];
      this.by_product_dict = data["by_product_dict"];
    }, (error) => {
      this.is_data_available = true;
      console.error(error);
    });
  }

  getDiscountBusiness() {
    this.httpService.serveBusinessTypeForByProductPrice().subscribe((data: []) => {
      console.log(data);
      this.business_types = data;
    }, (error) => {
      console.log(error);
    });
  }

  businesTypeValueChanged() {
    console.log(this.selected_business_type_id)
    let data_dict = {
      'business_type_id': this.selected_business_type_id
    };
    this.is_data_available = false;
    this.httpService.serveBusinessTypeWisePriceForByProduct(data_dict).subscribe((data) => {
      console.log(data);
      this.is_data_available = true;
      this.discount_price_for_selected_business_type = data;
    }, (error) => {
      this.is_data_available = true;
      console.log(error);
    });
  }

  checkValueAvailableInDict(product_id, for_value) {
    if (this.discount_price_for_selected_business_type.hasOwnProperty(product_id)) {
      if (this.discount_price_for_selected_business_type[product_id][for_value] == 0) {
        return 'N/A';
      } else {
        return this.discount_price_for_selected_business_type[product_id][for_value]
      }
    } else {
      return 'N/A';
    }
  }


  openDialog(business_type_id: number, product_id: number, product_name: string, price: number, value_for: string): void {
    console.log('dialog open');

    const dialogRef = this.dialog.open(BusinessTypeWiseProductPriceComponent, {
      height: '400px',
      width: '600px',
      data: {
        'business_type_id': business_type_id,
        'product_id': product_id,
        'product_name': product_name,
        'price': price,
        'value_for': value_for
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      console.log(res);
      if ((res !== null) && (res !== undefined)) {
        this.businesTypeValueChanged();
      }
    });
  }

  ngOnInit() {
  }

}
